export default __webpack_public_path__ + "static/media/eadbb595-a394-48fc-834f-8bf5da15cddf.ae967183.woff";